export const cn = (...classNames) => {
    return classNames.filter(Boolean).join(" ")
}

export const formatRoute = (route) => {
    if (route?.charAt?.(0) === "/") {
        return route.replace("/", "");
    }
    return route;
}

export const stringMerger = (...strings) => {
    return strings.filter(Boolean).join("");
}